export const addTableTicketStyle = {
	wrapper: {
		maxWidth: '970px',
		width: '100%',
		margin: '0 auto',
	},

	stepper: {
		width: '100%',
		margin: '40px 0',
		textTransform: 'capitalize',

		'& .MuiTypography-root': {
			lineHeight: '28px',
		},
	},
};
